import resume from '../assets/pdf/resume.pdf';
import profile from '../assets/png/profile.png';

export const headerData = {
    name: 'Dhivya Dharshni',
    title: "Learner| Developer",
    desciption:"A calm engineering student who is passion-driven to learn new technologies and solve problems. Everyday, I expect myself to be better than the other day :)",
    image: profile,
    resumePdf: resume
}

